'use client';

import React from 'react';
import { Loader2 } from 'lucide-react';
import { useLanguage } from '@/context/LanguageContext';
import ManagedVideoModal from '@/components/ui/ManagedVideoModal';
import { usePageVideo } from '@/hooks/usePageVideo';

interface FirstLoginVideoModalProps {
  open: boolean;
  dismissing?: boolean;
  onDismiss: () => void;
}

export default function FirstLoginVideoModal({
  open,
  dismissing = false,
  onDismiss,
}: FirstLoginVideoModalProps) {
  const { t } = useLanguage();
  const { video, loading } = usePageVideo('platform_intro');

  if (!open || loading || (!video?.media_url && !video?.youtube_url)) {
    return null;
  }

  return (
    <ManagedVideoModal
      open={open}
      onClose={onDismiss}
      title={video.label}
      description={t('firstLoginVideo.description')}
      eyebrow={t('firstLoginVideo.eyebrow')}
      youtubeUrl={video.youtube_url}
      mediaUrl={video.media_url}
      coverUrl={video.cover_url}
      footer={
        <div className="flex flex-col-reverse gap-2 sm:flex-row sm:justify-end">
          <button
            type="button"
            onClick={onDismiss}
            disabled={dismissing}
            className="inline-flex items-center justify-center rounded-lg border border-white/10 px-4 py-2 text-xs font-semibold text-zinc-200 transition-colors hover:border-brand-500/35 hover:text-white disabled:opacity-60"
          >
            {dismissing ? <Loader2 size={14} className="animate-spin" /> : null}
            {t('firstLoginVideo.skip')}
          </button>
        </div>
      }
    />
  );
}